import { useMemo } from 'react';

import { ColumnContainerJson, Present } from '/types';

import { createAnimationData } from './chartAnimations';

const useAnimation = (
  columnData: ColumnContainerJson[],
  presentMode: Present,
  animationStep: number,
  preChartSteps: number,
  setAnimationComplete: (animationComplete: boolean) => void,
): ColumnContainerJson[] => {
  // React does not recognise object equality so passing in string to dependency array
  const columnDataJson = JSON.stringify(columnData);
  const animationData = useMemo(() => {
    if (presentMode === Present.Keynote) {
      return createAnimationData(JSON.parse(columnDataJson), preChartSteps);
    }
    return [JSON.parse(columnDataJson)];
  }, [presentMode, columnDataJson, preChartSteps]);

  let columns = columnData;

  const totalSteps = animationData.length - 1;
  setAnimationComplete(animationStep >= totalSteps);

  if (presentMode === Present.Keynote) {
    columns = animationData[animationStep];
  }

  return columns;
};

export default useAnimation;
